import React from 'react';
import {ServerComponentCaller} from "../../helpers";

const Fyac = props => <ServerComponentCaller url={"/assets/data/pages/fyac.json"}/>

export default Fyac;
